var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIsland(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 640",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224 208C188.7 208 160 179.3 160 144C160 108.7 188.7 80 224 80C239.7 80 254 85.6 265.2 95C276.4 76.4 296.8 64 320 64C343.2 64 363.6 76.4 374.8 95C385.9 85.6 400.3 80 416 80C451.3 80 480 108.7 480 144C480 179.3 451.3 208 416 208C401.3 208 387.7 203 376.9 194.7L344.9 242.7C339.3 251 330 256 320 256C310 256 300.7 251 295.1 242.7L263.1 194.7C252.3 203 238.7 208 224 208zM208 416L256.4 391.8C266.6 386.7 278 384 289.4 384C309 384 327.8 391.8 341.6 405.6L374.1 438.1C380.4 444.4 389 448 397.9 448C409.2 448 419.7 442.4 425.9 433L435.6 418.4L376.6 352.1C367.5 341.9 354.4 336 340.7 336L298.9 336C285.2 336 272.1 341.9 263 352.1L203.1 419.5L207.8 416zM227.4 320.2C245.6 299.7 271.7 288 299.2 288L341 288C368.4 288 394.5 299.7 412.8 320.2L563 489.2C571.5 498.7 576.2 511.1 576.2 523.9C576.2 552.7 552.8 576.1 524 576.1L116.2 576C87.4 576 64 552.6 64 523.8C64 511.1 68.7 498.7 77.2 489.2L227.4 320.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsland);
export default __webpack_public_path__ + "static/media/island.8eb80754a63f8abc685414bf134fea70.svg";
export { ForwardRef as ReactComponent };